/**
 * Direct storefront price gates.
 *
 * The implementation lives in bo-components so that shared v2 components (bo-cart-list,
 * bo-document-line-item-list, the product matrices, …) can consume it without importing
 * out of the component library into frontend code. This module is kept as the entry point
 * the frontend modules already import from.
 */
export {
    resolveCanReadPrices,
    resolveCanReadDocumentPrices,
    resolveCanReadDocumentDetailPrices,
    resolveCanReadDocumentPdf,
    priceVisibilityMixin,
    documentPriceVisibilityMixin,
    documentDetailPriceVisibilityMixin,
    PRICE_COLUMN_IDS,
    filterPriceColumns,
    filterDocumentDetailPriceColumns,
    filterCatalogPriceColumns,
} from "@/v2/mixins/price-visibility.js";
